import dai_icon from '../images/coins/dai.svg';
import ether_icon from '../images/coins/ethereum-icon.svg';
import usdc_icon from '../images/coins/us-dollar-coin-icon.svg';


export const TempPositions = 
[
    {
       "posHash":"0xb5aaef2bb8c8f8fdfe94c2674e44048344ba575826778d22811d4f02794cc483",
       "posDetail":{
          "poolPrice":1050112955.7152635,
          "ambientLiq":"0",
          "baseQty":"0",
          "quoteQty":"0",
          "accumBaseFees":"0",
          "accumQuoteFees":"0",
          "lpType":"ambient",
          "owner":"0x50F09108b78290422e3cdB3153207e664e09f960",
          "baseTokenSymbol": "ETH",
          "baseTokenImage": ether_icon,
          "quoteTokenSymbol": "USDC",
          "quoteTokenImage": usdc_icon,
          "poolType":35000,
          "ambientSeeds":"0",
          "burnPending": false,
          "range": true
       },
       "txHashes":[
          "0xfc4cd838a9d48b8aacd9add6b242162d4be86bdd731c0f8a70434d3dbc6c01eb",
          "0x51d9302b0762426578a271728a41ab4db5ff565f9bbe872e7f7dfc256e79e2ae",
          "0xdd6c3cb8db80f3cb75e547fdfd28e88cedc57ab240d3beb6da79525365e48956",
          "0xf8ee293cb1f52a89c3784d0a89014108345f57d4e9d59d7eb5255c29c6f3795f",
          "0xb6fd2783f532399236c695a805a86e5d6979c69579b1ad537c6972e65517a7a1"
       ],
       "lastUpdated":"Wed Feb 23 2022 10:03:27 GMT-0600 (Central Standard Time)"
    },
    {
       "posHash":"0x446470a0a52f7dda475136985fd35e21958693821a321ea478944d9a381b5c71",
       "posDetail":{
          "poolPrice":1050112955.7152635,
          "lowerPrice":3338887728.6275206,
          "upperPrice":6231434344.89529,
          "ambientLiq":"0",
          "baseQty":"0",
          "quoteQty":"0",
          "accumBaseFees":"0",
          "accumQuoteFees":"0",
          "lpType":"range",
          "owner":"0x50F09108b78290422e3cdB3153207e664e09f960",
          "baseTokenSymbol":"ETH",
          "baseTokenImage": ether_icon,
          "quoteTokenSymbol": "USDC",
          "quoteTokenImage": usdc_icon,
          "poolType":35000,
          "lowerTick":219300,
          "upperTick":225540,
          "concLiq":"0",
          "feeMileage":0,
          "burnPending": false,
          "range": false
       },
       "txHashes":[
          "0x8d82f220769960a7afea3c8ff02911b23fd063eb5de2c9b80ff65e8c1ae391a8"
       ],
       "lastUpdated":"Fri Feb 18 2022 09:00:46 GMT-0600 (Central Standard Time)"
    },
    {
       "posHash":"0x2b1e7f866d68d5a34be03c09aa34f2a8db35bd4672ccfa77990e890c3a281acf",
       "posDetail":{
          "poolPrice":1050112955.7152635,
          "lowerPrice":3753286613.978217,
          "upperPrice":6983853477.692804,
          "ambientLiq":"0",
          "baseQty":"0",
          "quoteQty":"0",
          "accumBaseFees":"0",
          "accumQuoteFees":"0",
          "lpType":"range",
          "owner":"0x50F09108b78290422e3cdB3153207e664e09f960",
          "baseTokenSymbol":"ETH",
          "baseTokenImage": ether_icon,
          "quoteTokenSymbol": "USDC",
          "quoteTokenImage": usdc_icon,
          "poolType":35000,
          "lowerTick":220470,
          "upperTick":226680,
          "concLiq":"0",
          "feeMileage":0,
          "burnPending": false,
          "range": false
       },
       "txHashes":[
          "0xa170765ff7cf857a992d0cba77e63775e4df9bd44c4795daf3f55138fc103e85",
          "0xe887216e72cbf0ee7876d71f92ef9e23cd5d20684e61695f58e052df7d7790b6",
          "0x1ae4ad051e5f147938e4033e40b2bb9f7fbf9b598ade3dcdef223d163aa21f1e",
          "0x10dd521cd0a4f48f17762d9a38921544e476e6e5914d683bece4210716084ca8",
          "0x92597e65a7023f06207f5ccfc2ce1b6c321013c422c45003e9450ef176749567",
          "0xb3917545e0da87d977bd94a0d4b72d274e358499246fb127724904d4bdac5fe1",
          "0x27372d99779ea1b43b6ff8cb277292d84a69b41f8a1cbef5109a4b663f74844a"
       ],
       "lastUpdated":"Wed Feb 23 2022 11:38:29 GMT-0600 (Central Standard Time)"
    },
    {
       "posHash":"0xaeec3ecbe7a704d8becfde3bf95906d0a97b2d189ddf47427514713418a15c89",
       "posDetail":{
          "poolPrice":1050112955.7152635,
          "lowerPrice":2997093949.7837954,
          "upperPrice":4009347808.245384,
          "ambientLiq":"0",
          "baseQty":"0",
          "quoteQty":"288478",
          "accumBaseFees":"0",
          "accumQuoteFees":"0",
          "lpType":"range",
          "owner":"0x50F09108b78290422e3cdB3153207e664e09f960",
          "baseTokenSymbol":"ETH",
          "baseTokenImage": ether_icon,
          "quoteTokenSymbol": "USDC",
          "quoteTokenImage": usdc_icon,
          "poolType":35000,
          "lowerTick":218220,
          "upperTick":221130,
          "concLiq":"116635891712",
          "feeMileage":0,
          "burnPending": false,
          "range": false
       },
       "txHashes":[
          "0xe2e0a062786d05ce3c27c3a6c953ff2d9db2bd811419bd7f3b7285620f1c39a4"
       ],
       "lastUpdated":"Wed Feb 23 2022 09:42:09 GMT-0600 (Central Standard Time)"
    },
    {
       "posHash":"0x3fc4ad645c7bd0681dd17c8f45bd9e25326e3865b28ba99f51f0839428ef81e3",
       "posDetail":{
          "poolPrice":0.0008353511152113767,
          "ambientLiq":"15551432419966976",
          "baseQty":"449474363217058",
          "quoteQty":"538066395114962944",
          "accumBaseFees":"0",
          "accumQuoteFees":"0",
          "lpType":"ambient",
          "owner":"0x50F09108b78290422e3cdB3153207e664e09f960",
          "baseTokenSymbol":"ETH",
          "baseTokenImage": ether_icon,
          "quoteTokenSymbol": "DAI",
          "quoteTokenImage": dai_icon,

          "poolType":35000,
          "ambientSeeds":"15508228722038741",
          "burnPending": false,
          "range": true
       },
       "txHashes":[
          "0x72d8c07a6a0152fe2284dbcef58992eebab4edc6f57e3b6854f92eb2adbafecd",
          "0x7af4ef0c5e6ac0252015c3a6516f1e8c877b2f6fe63535db42f2dd56d93d703e",
          "0x291a9e2e22631404d8ffd10469c3716b546766bf2abce391c7f7b69eb83700bf",
          "0xe212a8bb891b56ec0b9f9ee17e6376ec6735d9463325b646973877159a9eac6d",
          "0x3d6d51338874baeb6dfb867cb7e033212a688a3f6af76afda1f6700e456c74f1"
       ],
       "lastUpdated":"Thu Mar 03 2022 12:30:06 GMT-0600 (Central Standard Time)"
    },
    {
       "posHash":"0x46e26dbc44c69b5fcd63834ef7405c1456516f111d956d789ff2bfaf9eba50e8",
       "posDetail":{
          "poolPrice":0.0008353511152113767,
          "lowerPrice":0.004104278887748832,
          "upperPrice":0.007659899493733432,
          "ambientLiq":"0",
          "baseQty":"0",
          "quoteQty":"3320041442270183424",
          "accumBaseFees":"0",
          "accumQuoteFees":"0",
          "lpType":"range",
          "owner":"0x50F09108b78290422e3cdB3153207e664e09f960",
          "baseTokenSymbol":"ETH",
          "baseTokenImage": ether_icon,
          "quoteTokenSymbol": "DAI",
          "quoteTokenImage": dai_icon,
          "poolType":35000,
          "lowerTick":-54960,
          "upperTick":-48720,
          "concLiq":"793625680504356864",
          "feeMileage":0,
          "burnPending": false,
          "range": false
       },
       "txHashes":[
          "0xbddd8a78f75d4e5efe74bcf28a3891f6bbc63800620339ebd5de8b770d8cb1c0"
       ],
       "lastUpdated":"Wed Feb 23 2022 14:22:26 GMT-0600 (Central Standard Time)"
    },
    {
       "posHash":"0xda81ac7228d6784dc8c57035c47b5ada3557d838bced71d65e8bce6f0ebcba2e",
       "posDetail":{
          "poolPrice":0.0008353511152113767,
          "lowerPrice":0.005523519300931323,
          "upperPrice":0.010246993174436694,
          "ambientLiq":"0",
          "baseQty":"0",
          "quoteQty":"343805413388255232",
          "accumBaseFees":"0",
          "accumQuoteFees":"0",
          "lpType":"range",
          "owner":"0x50F09108b78290422e3cdB3153207e664e09f960",
          "baseTokenSymbol":"ETH",
          "baseTokenImage": ether_icon,
          "quoteTokenSymbol": "DAI",
          "quoteTokenImage": dai_icon,
          "poolType":35000,
          "lowerTick":-51990,
          "upperTick":-45810,
          "concLiq":"96128637003694080",
          "feeMileage":3.846977847388189e-8,
          "burnPending": false,
          "range": false
       },
       "txHashes":[
          "0xa371091bae3e1057127136dc3b82224ba42bae4443353526ea85f853fdca4afd"
       ],
       "lastUpdated":"Thu Mar 03 2022 11:50:45 GMT-0600 (Central Standard Time)"
    }
 ]